import { render } from "./PaginationView.vue?vue&type=template&id=fb0161f6"
import script from "./PaginationView.vue?vue&type=script&lang=js"
export * from "./PaginationView.vue?vue&type=script&lang=js"

import "./PaginationView.vue?vue&type=style&index=0&id=fb0161f6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__